module.exports = __webpack_public_path__ + "img/tushi2.0d148369.jpg";